module.exports = __webpack_public_path__ + "media/images/icons/icon_circlechecklist_black-4b078b9a8bf78626b6cd30d1ddda6267.svg";